<template>
  <div class="poster-wrapper">
    <div class="btnTop">
      <Button v-if="edit" type="primary" @click="openModal()">新增</Button>
    </div>
    <no-data v-if="posterArr && posterArr.length == 0"></no-data>
    <div class="contentList" v-else>
      <div v-for="(item, index) in posterArr" :key="index" class="posterList" @mouseleave="control = false">
        <div class="poster">
          <img :src="item.url" :preview="_uid" :ref="'img' + index" />
          <div class="posterEdit">
            <img src="@static/images/product/down.png" alt="" @click="downloadFile(item)" />
            <img v-show="item.copywriting" src="@static/images/product/Twriting.png" alt="" @click="copywrite(item.copywriting)" />
            <img src="@static/images/product/openImg.png" alt="" @click="$refs['img' + index][0].click()" />
            <img src="@static/images/product/edit.png" alt="" @click.stop="control = !control" v-if="edit" />
            <div class="controls" v-if="control && edit" @click.stop="control = true">
              <span @click="editPost(item, index)">编辑</span>
              <span @click="deletePost(index)">删除</span>
            </div>
          </div>
          <div class="posterContent">
            <span>{{ item.copywriting }}</span>
          </div>
        </div>
        <div class="posterTitle">{{ item.title }}</div>
      </div>
    </div>
    <Modal class="my-modal" v-model="visible" :title="title" :mask-closable="false" :footer-hide="true">
      <Form ref="form" :model="formData" :label-width="90" class="formGauge">
        <FormItem label="图片" prop="url" :rules="$units.formRule.required('请选择图片')">
          <upLoadNew v-model="formData.imgArr" :isDel="edit" @change="imgUpload" @remove="$set(formData, 'url', '')"> </upLoadNew>
        </FormItem>
        <FormItem label="海报名称" prop="title" :rules="$units.formRule.required('请输入海报名称')">
          <Input :disabled="!edit" v-model="formData.title"></Input>
        </FormItem>
        <!-- <FormItem label="所属分类" prop="columnIds" :rules="$units.formRule.arrRequired('请选择所属分类', 'change')">
          <Select :disabled="!edit" v-model="formData.columnIds" :transfer="true" clearable multiple>
            <Option :value="items.id || ''" :key="items.id" v-for="items in polist">{{ items.name }}</Option>
          </Select>
        </FormItem> -->
        <!-- <FormItem label="展示机构" prop="orgIdList" key="orgIdList">
          <selectTree v-model="formData.orgIdList" :multiple="true" :maxTagCount="5" type="4" ref="selectTreeRef"
            :orgId="formData.buzOrganId" :showCloseIcon="false" :disabled="true"></selectTree>
        </FormItem> -->
        <FormItem label="海报文案" prop="copywriting">
          <Input :disabled="!edit" v-model="formData.copywriting" type="textarea"></Input>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="primary" @click="visible = false" ghost>取消</Button>
        <Button type="primary" @click="submit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import myForm from '@/components/commons/form';
import upLoad from '@/components/commons/upload';
import upLoadNew from '@/components/commons/uploadNew';
import selectTree from '@/components/system/selectTree3';
import { uploadFile } from '@/api/httpList';
export default {
  mixins: [common],
  props: {
    productForm: {
      type: Object
    },
    edit: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  components: {
    upLoad,
    myForm,
    upLoadNew,
    selectTree
  },
  data() {
    return {
      visible: false,
      control: false,
      title: '新增',
      posterArr: [],
      formData: {},
      polist: [],
      index: ''
    };
  },
  created() {
    if (this.$route.query.code) {
      this.productForm.productCode = this.$route.query.code;
    }
    this.getList();
    document.addEventListener('click', e => {
      this.control = false;
    });
  },
  methods: {
    // 下载文件
    downloadFile(item) {
      this.$units.downloadFile('/buz/common/downloadByUrl', { url: item.url }, 'GET', item.title + '.jpg');
    },
    deletePost(index) {
      this.$notice.inquiry('是否确认删除此选项？').then(async () => {
        this.posterArr.splice(index, 1);
        this.$http({
          url: '/buz/cms/productMaterial/add',
          type: 'POST',
          data: {
            productCode: this.productForm.productCode,
            postList: this.posterArr
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.getList();
        });
      });
    },
    editPost(val, index) {
      this.openModal(val, index);
      this.index = index;
    },
    // 文案复制
    copywrite(value) {
      let oInput = document.createElement('input');
      oInput.value = value;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand('Copy');
      oInput.remove();
      this.$Message.success('复制成功');
    },
    getList() {
      this.$http({
        url: ' /buz/cmsPoster/product/list',
        type: 'POST',
        data: {
          productCode: this.productForm.productCode
        }
      }).then(res => {
        this.posterArr = res.data;
        this.$previewRefresh();
      });
    },
    imgUpload() {
      if (this.formData.imgArr && this.formData.imgArr[0]) {
        this.$set(this.formData, 'url', this.formData.imgArr[0].path);
      }
      this.$refs.form.validateField('url');
    },
    openModal(val, index) {
      this.index = '';
      this.visible = true;
      this.$refs.form && this.$refs.form.resetFields();
      this.formData = {
        url: '',
        title: '',
        columnIds: [],
        copywriting: ''
      };
      this.getType();
      this.$nextTick(() => {
        this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange(true);
      });
      if (val) {
        this.title = '编辑';
        if (val.id) {
          this.$http({
            url: '/buz/cmsPoster/read/detail',
            type: 'GET',
            data: {
              id: val.id
            }
          }).then(res => {
            this.formData = res.data;
            if (this.formData.url) {
              this.formData.imgArr = [{ path: this.formData.url }];
            }
          });
        } else {
          this.formData = this.posterArr[index];
          if (this.formData.url) {
            this.formData.imgArr = [{ path: this.formData.url }];
          }
        }
      } else {
        this.title = '新增';
      }
    },
    getType() {
      this.$http({
        url: '/buz/cmsPoster/column/list',
        type: 'POST',
        data: {}
      }).then(res => {
        this.polist = res.data;
      });
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (this.index) {
          this.posterArr.forEach((item, index) => {
            if (index == this.index) {
              this.posterArr.splice(index, 1, this.formData);
            }
          });
        } else {
          this.posterArr.push(this.formData);
        }
        if (valid) {
          this.$http({
            url: '/buz/cms/productMaterial/add',
            type: 'POST',
            data: {
              productCode: this.productForm.productCode,
              postList: this.posterArr
            }
          })
            .then(res => {
              this.visible = false;
              this.getList();
            })
            .catch(() => {
              this.getList();
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.poster-wrapper {
  .btnTop {
    margin-top: 30px;
    margin-left: 40px;
  }

  .contentList {
    display: flex;
    flex-wrap: wrap;

    .posterList {
      margin-right: 30px;
      margin-top: 30px;

      .poster {
        width: 240px;
        height: 426px;
        position: relative;

        &:hover .posterContent {
          display: block;
        }

        .posterContent {
          display: none;
          position: absolute;
          width: 240px;
          height: 70px;
          border-radius: 0px 0px 10px 10px;
          bottom: 0;
          right: 0;
          background: #000;
          opacity: 0.8;
          padding: 8px 12px;

          span {
            display: block;
            color: #fff;
            font-size: 12px;
            line-height: 18px;
            font-family: PingFang SC;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }

        &:hover .posterEdit {
          display: block;
        }

        .posterEdit {
          display: none;
          position: absolute;
          top: 10px;
          right: 0;
          cursor: pointer;

          .controls {
            margin: 10px;
            background: #fff;
            width: 84px;
            height: 100%;

            span {
              display: block;
              height: 30px;
              line-height: 30px;
              text-align: center;
            }
          }

          img {
            width: 26px;
            height: 26px;
            margin-right: 10px;
          }
        }

        img {
          width: 240px;
          height: 426px;
          border-radius: 10px;
          object-fit: cover;
          object-position: top;
        }
      }
    }

    .posterTitle {
      max-width: 240px;
      margin-top: 12px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
/deep/ .wrapper .demo-upload-list img {
  object-fit: cover;
  object-position: top;
}
</style>
